import React from 'react';
import { Alert } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const ApiKeyWarning = () => {
    return (
        <Alert color="warning" className="api-key-warning">
            <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
            <strong>Warning:</strong> User is either disabled and/or not an active admin user. API Keys will not work.
        </Alert>
    );
};

export default ApiKeyWarning;
